const debug = require('debug')('OD::Store:Global')

const state = {
  leftSideMenu: false,
  defaultSport: '',
  boardMode: 'advanced',
}

const getters = {}

const mutations = {
  SET_DEFAULT_SPORT(state, { sport }) {
    debug('SET_DEFAULT_SPORT', sport)
    state.defaultSport = sport
  },
  SET_BOARD_MODE(state, { mode }) {
    debug('SET_BOARD_MODE', mode)
    state.boardMode = mode
  },
  TOOGLE_SIDE_MENU(state) {
    debug('TOOGLE_SIDE_MENU')
    state.leftSideMenu = !state.leftSideMenu
  },
}

const actions = {
  setDefaultSport({ commit }, { sport }) {
    debug('setDefaultSport', sport)
    commit('SET_DEFAULT_SPORT', { sport })
  },
  setBoardMode({ commit }, { mode }) {
    debug('setBoardMode', mode)
    commit('SET_BOARD_MODE', { mode })
  },
  toogleSideMenu({ commit }) {
    debug('toogleSideMenu')
    commit('TOOGLE_SIDE_MENU')
  },
}

export default { namespaced: true, state, mutations, actions, getters }
